/**
 * Creates a Donut Chart using Chart.js
 */
import DonutChart from "./charts/donut_chart.js";

/**
 * Hook to define a DonutChart inside of LiveView
 * 
 * ### Example
      <canvas
        phx-hook="DonutChartHook"
        phx-update="ignore"
        id={"my-donut-chart"}
        data-key="my_key"
        data-canvas-id={"my-donut-chart"}
        data-good={50}
        data-fair={20}
        data-bad={30} />

      {:noreply, push_event(socket, "my_key_update", %{good: 55, fair: 15, bad: 30})
 */
export const DonutChartHook = {
  mounted() {
    this.chart = new DonutChart(this.el.dataset.canvasId);

    this.handleEvent(`${this.el.dataset.key}_update`, (data) => {
      this.chart.update(data);
    });
  },

  destroyed() {
    this.chart.destroy();
  },
};
